import { render, staticRenderFns } from "./ButtonSendTx.vue?vue&type=template&id=648832c4&scoped=true&functional=true&"
import script from "./ButtonSendTx.vue?vue&type=script&lang=js&"
export * from "./ButtonSendTx.vue?vue&type=script&lang=js&"
import style0 from "./ButtonSendTx.vue?vue&type=style&index=0&id=648832c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "648832c4",
  null
  
)

export default component.exports